import React, { useEffect, useState } from "react";
import {
  AiOutlineSearch,
  AiOutlineHeart,
  AiOutlineShoppingCart,
} from "react-icons/ai";

import logo from "../assets/logo.png";

const Navbar = ({ showCart, setShowCart, cartItems }) => {
  const [nav, setNav] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 30) {
      setNav(true);
    } else {
      setNav(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`${
        !nav
          ? "fixed top-5 right-0 left-0 opacity-100 z-[100]"
          : "h-[9vh] fixed blur-effect-theme top-0 left-0 right-0 flex items-center justify-center opacity-100 z-[100] "
      }`}
    >
      <nav className="flex items-center justify-between nike-container">
        <div className={`flex items-center `}>
          <img
            src={logo}
            alt="logo-img"
            className={`w-16 h-auto ${nav && "filter brightness-0"}`}
          />
        </div>
        <div>
          <ul className="flex items-center justify-center gap-2">
            <li className="grid cur items-center hover:cursor-pointer">
              <AiOutlineHeart
                className={`icon-style ${
                  nav &&
                  "text-slate-900 transition-all duration-700 ease-in-out"
                }`}
              />
            </li>
            <li className="grid cur items-center hover:cursor-pointer">
              <AiOutlineSearch
                className={`icon-style ${
                  nav &&
                  "text-slate-900 transition-all duration-700 ease-in-out"
                }`}
              />
            </li>
            <li
              onClick={() => setShowCart(!showCart)}
              className="grid cur items-center cursor-pointer relative"
            >
              <AiOutlineShoppingCart
                className={`icon-style ${
                  nav &&
                  "text-slate-900 transition-all duration-700 ease-in-out"
                }`}
              />
              <span className="absolute -top-2 -right-1 bg-slate-300 rounded-full h-4 w-4 text-center text-xs">
                {cartItems?.length}
              </span>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
